"use client"

import { useState } from "react"
import { cn, copyToClipboard } from "@/lib/utils"
import {
    Tooltip,
    TooltipContent,
    TooltipTrigger,
} from "@/components/ui/tooltip"
import { CA } from "@/lib/constants"

export function CopyableCA({
    className,
    withLabel = true,
}: {
    className?: string
    withLabel?: boolean
}) {
    const [showTooltip, setShowTooltip] = useState(false)

    const handleCopy = () => {
        copyToClipboard(CA)
        setShowTooltip(true)
        setTimeout(() => setShowTooltip(false), 2000) // Hide tooltip after 2 seconds
    }

    return (
        <Tooltip open={showTooltip}>
            <TooltipTrigger asChild>
                <p
                    className={cn(
                        className,
                        "glass-effect group cursor-pointer gap-2 rounded-none p-2 text-sm break-all transition-colors duration-150 hover:bg-white/5 active:bg-white/10",
                    )}
                    onMouseDown={handleCopy}
                >
                    {withLabel && <span>CA:</span>}
                    {withLabel && ` `}
                    <span className="">{CA}</span>
                </p>
            </TooltipTrigger>
            <TooltipContent side="right">
                <p className="text-sm font-bold">Copied!</p>
            </TooltipContent>
        </Tooltip>
    )
}
